/**
 *
 *
 * @class RAF
 */
class RAF {
  /**
   * Creates an instance of RAF.
   *
   * @memberOf RAF
   */
  constructor () {
    this.listeners = []
    this._update = this._update.bind(this)
    this._update()
  }
  /**
   *
   *
   * @param {any} listener
   *
   * @memberOf RAF
   */
  add (listener) {
    let index = this.listeners.indexOf(listener)
    if (index === -1) {
      this.listeners.push(listener)
    }
  }
  /**
   *
   *
   * @param {any} listener
   *
   * @memberOf RAF
   */
  remove (listener) {
    let index = this.listeners.indexOf(listener)
    if (index !== -1) {
      this.listeners.splice(index, 1)
    }
  }
  /**
   *
   *
   *
   * @memberOf RAF
   */
  _update () {
    this.listeners.forEach(this._updateListener)
    window.requestAnimationFrame(this._update)
  }
  /**
   *
   *
   * @param {any} listener
   *
   * @memberOf RAF
   */
  _updateListener (listener) {
    listener()
  }
}

export default new RAF()



// WEBPACK FOOTER //
// ./src/utils/RAF.js